import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { betLoopPrincipleProfileQuery } from '@core/Areas/BetLoop/helpers/queries'

export const useShouldStartOnboarding = () => {
  const isOnboardingRef = React.useRef(false)
  const [onboardingStatus, setOnboardingStatus] = React.useState<OnboardingCheckStatus>('checking')

  const { data, isLoading, isError } = useQuery(betLoopPrincipleProfileQuery)

  const hasCreatedProfile = !isError && data && data !== null && data.id
  const hasNoProfile = !isError && data === null

  React.useEffect(() => {
    if (isOnboardingRef.current) return

    if (hasCreatedProfile) {
      setOnboardingStatus('existing-profile')
      return
    }

    if (!hasCreatedProfile && !isLoading && hasNoProfile) {
      isOnboardingRef.current = true
      setOnboardingStatus('no-profile-found')
      return
    }
  }, [hasCreatedProfile, isLoading, hasNoProfile])

  const handleOnboardStatusSuccess = () => {
    isOnboardingRef.current = false
    setOnboardingStatus('onboarding-complete')
  }

  return { onboardingStatus, handleOnboardStatusSuccess }
}

// =====
// Types
// =====

type OnboardingCheckStatus =
  | 'checking'
  | 'existing-profile'
  | 'no-profile-found'
  | 'onboarding-complete'
